import * as actionType from "../constants";
import * as commonData from "../Common";

export const getBoardStatusDetails = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}board-details`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.GET_BOARD_STATUS_DETAILS,
        payload: rdata.data[0],
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};
